module.exports = __webpack_public_path__ + "static/media/pci-dss.d0c4604c_UI.svg";